import { Routes } from '@angular/router';
import { RouterEnum } from '@retail-portal-santander-frontend/shared-utils';
import { paymentGuard } from './guards/payment.guard';

export const santanderRoutes: Routes = [
  {
    path: '',
    redirectTo: RouterEnum.FamilyMembers,
    pathMatch: 'full',
  },
  {
    path: RouterEnum.FamilyMembers,
    loadChildren: async () =>
      (await import('@retail-portal-santander-frontend/family-member-feature')).familyMemberFeatureRoutes,
  },
  // {
  //   path: RouterEnum.Basket,
  //   loadChildren: async () => (await import('@retail-portal-santander-frontend/basket-feature')).basketFeatureRoutes,
  // },
  {
    path: RouterEnum.Payment,
    loadChildren: async () => (await import('@retail-portal-santander-frontend/payment-feature')).paymentFeatureRoutes,
    canActivate: [paymentGuard],
  },
  {
    path: '**',
    redirectTo: RouterEnum.FamilyMembers,
  },
];
